// Escribe "Mendique" con la tipografía del logo en cualquier texto de la web.
// Hace falta en JS porque los textos vienen del panel de Shopify (páginas y
// bloques de texto enriquecido) y Shopify borra los <span class> que se
// carguen a mano.
(function () {
  var SALTAR = /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT|OPTION|TITLE|CODE|PRE)$/;

  function pintar(raiz) {
    if (!raiz) return;
    var recorrido = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, {
      acceptNode: function (nodo) {
        var padre = nodo.parentElement;
        if (!padre) return NodeFilter.FILTER_REJECT;
        if (SALTAR.test(padre.tagName)) return NodeFilter.FILTER_REJECT;
        if (padre.closest('.mq-nombre, .header__heading-link')) return NodeFilter.FILTER_REJECT;
        return nodo.nodeValue.indexOf('Mendique') === -1
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      },
    });

    var pendientes = [];
    var nodo;
    while ((nodo = recorrido.nextNode())) pendientes.push(nodo);

    pendientes.forEach(function (texto) {
      var partes = texto.nodeValue.split('Mendique');
      var bloque = document.createDocumentFragment();
      partes.forEach(function (parte, i) {
        if (i > 0) {
          var marca = document.createElement('span');
          marca.className = 'mq-nombre';
          marca.textContent = 'Mendique';
          bloque.appendChild(marca);
        }
        if (parte) bloque.appendChild(document.createTextNode(parte));
      });
      texto.parentNode.replaceChild(bloque, texto);
    });
  }

  function arrancar() {
    pintar(document.querySelector('main') || document.body);
    pintar(document.querySelector('.footer'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
